<template>
  <div>
    <VueApexCharts
      :key="chartkey"
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></VueApexCharts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
export default {
  props: ['data'],
  components: {
    VueApexCharts
  },
  data() {
    return {
      chartkey: 0,
      series: [
        {
          data: [
            // { x: 'Bot', y: 50 },
            // { x: 'Admin', y: 40 },
          ]
        }
      ],
      chartOptions: {
        colors: ['#bababa', '#FF706B'],
        chart: {
          theme: {
            palette: 'palette1' // upto palette10
          },
          type: 'bar',
          height: 5
        },
        plotOptions: {
          bar: {
            columnWidth: '30%',
            barHeight: '50%',
            distributed: true,
            dataLabels: {
              position: 'right' // top, center, bottom
            },
            borderRadius: 4,
            horizontal: false
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },
        xaxis: {
          title: {
            text: 'Closed by'
          },
          categories: []
        },
        yaxis: {
          title: {
            text: 'Case'
          },
          categories: []
        }
      }
    }
  },
  mounted() {
    if (this.data) {
      this.series[0].data = [
        { x: 'Bot', y: this.data.closeByBot },
        { x: 'Admin', y: this.data.closeByAdmin }
      ]
      // var memberdata = this.data
      //   .map((el) => moment(el).format('YYYY-MM-DD'))
      //   .sort(function (a, b) {
      //     a = a.split('-').join('')
      //     b = b.split('-').join('')
      //     return a > b ? 1 : a < b ? -1 : 0
      //   })
      // var counts = {}
      // memberdata.forEach(function (x) {
      //   counts[x] = (counts[x] || 0) + 1
      // })
      // var series = []
      // for (const item in counts) {
      //   series.push({ x: item, y: counts[item] })
      // }
      // this.series[0].data = series
      this.chartkey++
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/agentmanagement/OverviewAdminChart.vue